
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#FF8A8C"}}),_c('path',{attrs:{"d":"M11.501 16H8.923V8.727h2.6c.73 0 1.36.146 1.889.437.528.289.934.704 1.218 1.247.286.542.43 1.19.43 1.946 0 .757-.144 1.408-.43 1.953a2.953 2.953 0 01-1.226 1.253c-.53.291-1.164.437-1.903.437zm-1.04-1.318h.976c.455 0 .837-.08 1.147-.24.313-.164.547-.416.703-.757.159-.344.238-.786.238-1.329 0-.537-.08-.976-.238-1.317a1.54 1.54 0 00-.7-.753c-.31-.16-.692-.241-1.146-.241h-.98v4.637z","fill":"#000"}})])
          )
        }
      }
    